import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FF4B55"
  }} d="M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621  c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38  C512,406.557,494.833,423.724,473.655,423.724z" /><g><path style={{
      fill: "#F5F5F5"
    }} d="M11.668,99.091l350.263,324.633h26.483L28.014,89.695C21.779,91.436,16.188,94.71,11.668,99.091z" /><path style={{
      fill: "#F5F5F5"
    }} d="M500.332,412.909L150.069,88.276h-26.483l360.399,334.029   C490.221,420.564,495.812,417.29,500.332,412.909z" /></g><polygon style={{
    fill: "#464655"
  }} points="26.483,88.276 388.414,423.724 485.517,423.724 123.586,88.276 " /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };